import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useApi } from '../../contexts/ApiContext';
import { useApp } from '../../contexts/AppContext';


const History: React.FC = () => {
    const { updateActions, updateBreadcrumbs } = useApp();
    const navigate = useNavigate();
    const { apiService } = useApi();

    const theme = useTheme();

    useEffect(() => {
        updateActions([
            <Button key={"create"} color='blackButton' onClick={() => navigate("/implantation/create")}> + Add New Cycle</Button>
        ]);
        updateBreadcrumbs([{
            label: "Implantation Window", onClick: () => {
                navigate("/implantation");
            }
        }]);

    }, []);

    return (
        <></>
    );
};

export default History;
